'use strict';

var SystemStatusServiceSentRequestDirective = function SystemStatusServiceSentRequestDirective() {
  return {
    restrict: 'E',
    template: require('../templates/system-status-service-sent-request.html'),
    link: function link($scope) {
      $scope.$on('statusMessage:show', function () {
        $scope.requestParsedContent = $scope.modalData.statusContent;
        $scope.requestStatus = $scope.modalData.status;
      });
    }
  };
};
SystemStatusServiceSentRequestDirective.$inject = [];
module.exports = SystemStatusServiceSentRequestDirective;